<template>
  <ion-page>
    <ion-content class="bg-grad-content">
      <div
        id="map"
        style="height: 100vh; width: 100%"
        slot="fixed"
        class="margin-top-xl"
      ></div>
    </ion-content>
    <ion-footer class="footermap">
      <ion-row>
        <ion-col
          class="ion-text-center"
          @click="
            $router.push({ name: 'messageme' }),
              this.$store.dispatch('app/keepPageState', true)
          "
        >
          <i class="mdi mdi-email-edit mdi-36px"></i>
        </ion-col>
        <ion-col class="ion-text-center" @click="showInfoMapPane">
          <i class="mdi mdi-map-marker-path mdi-36px"></i>
        </ion-col>
        <ion-col
          class="ion-text-center"
          @click="!loadDataFromPL ? $emitter.emit('open-fpl') : null"
        >
          <i
            class="mdi mdi-36px"
            :class="
              !loadDataFromPL ? 'mdi-shopping' : 'mdi-timer-sand mdi-spin'
            "
          ></i>
        </ion-col>
      </ion-row>
    </ion-footer>
    <div
      class="cupertino-pane cup-pane-map"
      style="display: none"
      id="cupertino-pane-info-map"
    >
      <div
        class="picture"
        style="background-image: url('/img/fachada.png');"
        @click="zoomImage"
      ></div>
      <div class="content" overflow-y>
        <div class="">
          <ion-list class="map-info-list">
            <ion-list-header>
              Lion Motos
            </ion-list-header>

            <ion-item>
              <i slot="start" class="mdi mdi-map-marker-radius mdi-36px"> </i>
              <ion-label>
                <h2>{{ this.$store.state.app.config.site.address.line1 }}</h2>
                <h3>{{ this.$store.state.app.config.site.address.line2 }}</h3>
              </ion-label>
            </ion-item>
            <ion-item>
              <i slot="start" class="mdi mdi-watch-variant mdi-36px"> </i>
              <ion-label>
                <h2>
                  {{ this.$store.state.app.config.site.servicetime.line1 }}
                </h2>
                <h3>
                  {{ this.$store.state.app.config.site.servicetime.line2 }}
                </h3>
              </ion-label>
            </ion-item>
            <ion-item>
              <i slot="start" class="mdi mdi-phone-classic mdi-36px"> </i>
              <ion-label>
                <h2>{{ this.$store.state.app.config.site.phone.fixed1 }}</h2>
                <h2>{{ this.$store.state.app.config.site.phone.mobile1 }}</h2>
              </ion-label>
            </ion-item>
            <ion-item>
              <i slot="start" class="mdi mdi-at mdi-36px"> </i>
              <ion-label>
                <h2>{{ this.$store.state.app.config.site.mail.address1 }}</h2>
              </ion-label>
            </ion-item>
          </ion-list>
        </div>
        <div class="description">
          <div class="powered">
            <div class="icon">
              <img src="/img/icons/android-chrome-192x192.png" alt="nike-app" />
            </div>
            <div class="title">
              <div class="by">
                Powered by
              </div>
              <div class="name">
                Lion
                <!-- <div class="age">4+</div> -->
              </div>
            </div>
          </div>
          <div class="store" @click="$router.push({ name: 'home' })">
            inicio
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </div>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import { CupertinoPane } from 'cupertino-pane'
import { actionSheetController, modalController } from '@ionic/vue'
export default {
  ionViewDidEnter() {
    if (!this.$store.getters['app/keepPageState']) {
      if (this.map) {
        this.moveToLocation()
      }
      this.$emitter.emit('full-loader')
    }
    this.$store.dispatch('app/keepPageState', false)
  },
  ionViewDidLeave() {},
  ionViewWillEnter() {
    if (!this.$store.getters['app/keepPageState']) {
      this.$emitter.emit('full-loader', { open: true })
    }
  },
  ionViewWillLeave() {
    if (this.myPane && this.myPane.isPanePresented())
      this.myPane.destroy({ animate: true })
  },
  components: {},
  data(vm) {
    return {
      map: null,
      loadDataFromPL: false,
      myPane: null,
      paneReBuild: true,
      settingsPaneMap: {
        initialBreak: 'top',
        breaks: {
          top: { enabled: true, height: 450 },
          middle: { enabled: false },
          bottom: { enabled: false }
        },
        backdrop: true,
        backdropOpacity: 0.4,
        topperOverflow: false,
        bottomClose: false,
        buttonClose: true,
        showDraggable: false,
        bottomOffset: 8,
        freeMode: true,
        onBackdropTap: () => vm.destroyDrawer()
      },
      picture: '/img/fachada.png'
    }
  },
  created() {},
  beforeUnmount() {},
  mounted() {
    this.initMap()
    window.addEventListener('orientationchange', (event) => {
      if (this.myPane && this.myPane.isPanePresented())
        this.myPane.destroy({ animate: true })
      this.paneReBuild = true
    })
  },
  computed: {},
  methods: {
    async zoomImage() {
      this.destroyDrawer()
      this.$store.dispatch('app/keepPageState', true)
      this.$store.dispatch('app/imageToView', this.picture)
      this.$router.push({ name: 'view-image' })
    },
    async destroyDrawer() {
      this.myPane.destroy({ animate: true })
    },
    showInfoMapPane() {
      if (this.$store.state.app.orientation === 'landscape') {
        this.$emitter.emit('toast', {
          message: 'Gire su dispositivo para una mejor experiencia',
          color: 'warning'
        })
        return false
      }
      if (this.paneReBuild) {
        this.myPane = null
        this.myPane = new CupertinoPane(
          '#cupertino-pane-info-map',
          this.settingsPaneMap
        )
        this.paneReBuild = false
      }
      this.myPane.present({ animate: true })
    },
    initMap() {
      var marker

      var contentString =
        '<div id="content" class="mapNoticeContent">' +
        '<div id="siteNotice">' +
        '</div>' +
        '<h1 id="firstHeading" class="firstHeading">Lion Motos</h1>' +
        '<div id="bodyContent">' +
        '<p><b>Cr 69B # 75 - 44 | Las Ferias | Bogotá, Colombia</b>.</p>' +
        '<p><a href="https://maps.google.com/maps?ll=4.68475,-74.08538&z=19&t=m&hl=es-419&gl=US&mapclient=apiv3&cid=3200656428973164192" target="_blank">Ver en google maps</a></p>' +
        '</div>' +
        '</div>'

      var infowindow = new google.maps.InfoWindow({
        content: contentString
      })
      var myLatLng = { lat: 4.68475, lng: -74.08538 }

      this.map = new google.maps.Map(document.getElementById('map'), {
        zoom: 19,

        center: myLatLng,

        scrollwheel: false,
        mapTypeControl: false,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.TOP_CENTER
        },
        zoomControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_CENTER
        },
        scaleControl: true,
        streetViewControl: true,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP
        },
        fullscreenControl: true
      })

      var image = '/img/icons/favicon-32x32.png'

      marker = new google.maps.Marker({
        position: myLatLng,

        map: this.map,

        draggable: true,

        animation: google.maps.Animation.DROP,

        title: 'Cr 69B # 75 - 44 | Las Ferias - Bogotá, Colombia',

        icon: image
      })

      marker.addListener('click', () => {
        infowindow.open(this.map, marker)
        this.showInfoMapPane()
      })

      marker.setAnimation(google.maps.Animation.BOUNCE)

      infowindow.open(this.map, marker)

      const centerControlDiv = document.createElement('div')
      this.CenterControl(centerControlDiv, this.map)
      this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
        centerControlDiv
      )
    },
    CenterControl(controlDiv, map) {
      // Set CSS for the control border.
      const controlUI = document.createElement('div')
      controlUI.style.backgroundColor = '#fff'
      controlUI.style.border = '2px solid #fff'
      controlUI.style.borderRadius = '3px'
      controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
      controlUI.style.cursor = 'pointer'
      controlUI.style.marginBottom = '22px'
      controlUI.style.textAlign = 'center'
      controlUI.classList.add('centerbtn')
      controlUI.title = 'Click para centrar el mapa'
      controlDiv.appendChild(controlUI)
      const controlIcon = document.createElement('i')
      controlIcon.classList.add('mdi')
      controlIcon.classList.add('mdi-target')
      controlIcon.classList.add('mdi-36px')
      controlUI.appendChild(controlIcon)
      // Setup the click event listeners: simply set the map to lion.
      controlUI.addEventListener('click', () => {
        this.moveToLocation()
      })
    },
    moveToLocation() {
      var myLatLng = { lat: 4.68475, lng: -74.08538 }
      const center = new google.maps.LatLng(myLatLng)
      this.map.panTo(center)
    }
  }
}
</script>

<style>
.mapNoticeContent {
  color: black;
}
.footermap {
  background: rgba(255, 0, 34, 0.4);
}

.cup-pane-map {
  color: white;
}
.cup-pane-map ion-item {
  --background: transparent;
  --border-color: transparent;
}

.map-info-list {
  background: transparent;
}

.ios .centerbtn {
  margin-top: 5px;
}
.md .centerbtn {
  margin-top: 10px;
}
</style>
